<template>
<div v-if="thumbnailType === 1" :class="className" :style="style" id="test">
  <div class="c-iframe__wrap-p1--sp">
    <Iframe
      v-if="createThumbnailBy === 'url'"
      className="c-iframe__fv--sp"
      :style="iframeStyle.p1.sp"
      :src="prevUrl"></Iframe>
    <Img v-else className="c-img" :src="prevFileSp"></Img>
  </div>
  <div class="c-iframe__wrap-p1--pc">
    <Iframe
      v-if="createThumbnailBy === 'url'"
      className="c-iframe__fv--pc"
      :style="iframeStyle.p1.pc"
      :src="prevUrl"></Iframe>
    <Img v-else className="c-img" :src="prevFilePc"></Img>
  </div>
  <Img class="c-img__pos00" :src="src.mockP1"></Img>
  <Img :src="src.mockPc"></Img>
</div>

<div v-else-if="thumbnailType === 2" :class="className" :style="style" id="test">
  <div class="c-iframe__wrap-p2--sp">
    <Iframe
      v-if="createThumbnailBy === 'url'"
      className="c-iframe__fv--sp"
      :style="iframeStyle.p1.sp"
      :src="prevUrl"></Iframe>
    <Img v-else  className="c-img" :src="prevFileSp"></Img>
  </div>
  <div class="c-iframe__wrap-p2--pc">
    <Iframe
      v-if="createThumbnailBy === 'url'"
      className="c-iframe__fv--pc"
      :style="iframeStyle.p1.pc"
      :src="prevUrl"></Iframe>
    <Img v-else  className="c-img" :src="prevFilePc"></Img>
  </div>
  <Img class="c-img__pos00" :src="src.mockP2"></Img>
</div>
</template>

<script>
import Store from '../../store/index.js'
import Iframe from '@/components/atoms/Iframe.vue'
import Img from '@/components/atoms/Img.vue'

export default {
  components: {
    Iframe,
    Img
  },
  props: {
    createThumbnailBy: String,
    className: String
  },
  data () {
    return {
      thumbnailTypeP1: Store.state.thumbnailType.p1,
      thumbnailTypeP2: Store.state.thumbnailType.p2,
      style: Store.state.bgStyle,
      src: {
        mockP1: Store.state.mockup.p1,
        mockP2: Store.state.mockup.p2
      },
      window: {
        width: window.innerWidth
      },
      iframeStyle: {
        p1: {
          sp: {
            transform: 'none'
          },
          pc: {
            transform: 'none'
          }
        },
        p2: {
          sp: {
            transform: 'none'
          },
          pc: {
            transform: 'none'
          }
        }
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleScale())
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.handleScale())
  },
  computed: {
    prevUrl () {
      return Store.state.url
    },
    prevFilePc () {
      if (Store.state.file.pc) {
        return window.URL.createObjectURL(Store.state.file.pc)
      } else {
        return null
      }
    },
    prevFileSp () {
      if (Store.state.file.sp) {
        return window.URL.createObjectURL(Store.state.file.sp)
      } else {
        return null
      }
    },
    thumbnailType () {
      let type = Number
      Store.state.thumbnailType.p1 ? type = 1 : type = 2
      return type
    }
  },
  methods: {
    handleScale () {
      this.iframeStyle.p1.sp.transform = `scale(${0.22 / 1280 * window.innerWidth})`
      this.iframeStyle.p1.pc.transform = `scale(${0.27 / 1280 * window.innerWidth})`
      this.iframeStyle.p2.sp.transform = `scale(${0.22 / 1280 * window.innerWidth})`
      this.iframeStyle.p2.pc.transform = `scale(${0.27 / 1280 * window.innerWidth})`
    }
  }
}
</script>

<style lang="scss" scoped>
.c-iframe__wrap {

  &-p1 {
    &--pc {
      width: 345/1280*100vw;
      height: 216/1280*100vw;
      overflow: hidden;
      position: absolute;
      top: 21.5%;
      left: 12.5%;
    }
    &--sp {
      width: 81/1280*100vw;
      height: 160/1280*100vw;
      border-radius: 0, 0, 5px, 5px;
      overflow: hidden;
      position: absolute;
      top: 41%;
      left: 81%;
    }
  }

  &-p2 {
    &--pc {
      width: 345/1280*100vw;
      height: 216/1280*100vw;
      overflow: hidden;
      transform: rotateX(16deg) rotateY(-31.9deg) rotateZ(4.5deg) scale(0.87);
      transform-origin: left top;
      position: absolute;
      top: 23.3%;
      left: 41.8%;
    }
    &--sp {
      width: 85/1280*100vw;
      height: 175/1280*100vw;
      border-radius: 5px 15/1280*100vw 15/1280*100vw 8px;
      overflow: hidden;
      transform: rotateX(32deg) rotateY(30deg) rotateZ(-23.8deg) translateZ(100/1280*100vw) scale(0.91);
      transform-origin: left top;
      position: absolute;
      top: 57.1%;
      left: 2.4%;
    }
  }
}
</style>
